import { render, staticRenderFns } from "./dialog-createrelation.vue?vue&type=template&id=c3ce8bd2&"
import script from "./dialog-createrelation.vue?vue&type=script&lang=js&"
export * from "./dialog-createrelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports